import { Link, useLocation } from "wouter";
import { Bookmark, CalendarDays, Compass, List, Map, Plus, Star, User } from "lucide-react";
import { useT } from "../lib/i18n";

export const TABS = [
  { href: "/", labelKey: "nav.map", icon: Map },
  { href: "/feed", labelKey: "nav.feed", icon: List },
  { href: "/discover", labelKey: "nav.discover", icon: Compass },
  { href: "/new", labelKey: "nav.new", icon: Plus },
  { href: "/calendar", labelKey: "nav.calendar", icon: CalendarDays },
  { href: "/ticklist", labelKey: "nav.ticklist", icon: Star },
  { href: "/saved", labelKey: "nav.saved", icon: Bookmark },
  { href: "/profile", labelKey: "nav.profile", icon: User },
] as const;

// Mobile bar drops ticklist/saved (reachable from the profile page) and centers "new".
const MOBILE_TABS = (["/", "/feed", "/new", "/discover", "/profile"] as const).map(
  (href) => TABS.find((tab) => tab.href === href)!,
);

/** Bottom tab bar, mobile only. */
export function TabBar() {
  const [location] = useLocation();
  const { t } = useT();
  return (
    <nav className="fixed inset-x-0 bottom-0 z-30 flex border-t bg-background/90 pb-[env(safe-area-inset-bottom)] backdrop-blur-md sm:hidden">
      {MOBILE_TABS.map((tab) => {
        const active = tab.href === "/" ? location === "/" : location.startsWith(tab.href);
        const Icon = tab.icon;
        return (
          <Link
            key={tab.href}
            href={tab.href}
            aria-current={active ? "page" : undefined}
            className={`flex flex-1 flex-col items-center gap-1 py-2.5 text-[11px] font-medium transition-colors ${
              active ? "text-primary" : "text-muted-foreground"
            }`}
          >
            <Icon
              aria-hidden
              className={`size-5 transition-transform duration-150 ${active ? "scale-110" : ""}`}
            />
            {t(tab.labelKey)}
          </Link>
        );
      })}
    </nav>
  );
}
